
import React from 'react'
import ClipLoader from 'react-spinners/ClipLoader'

const ButtonLoader = ({ style = {} }) => (
  <ClipLoader size={12} color='#aaa' css={{ marginLeft: 5, ...style }}/>
)

export default ButtonLoader
